export const environment = {
    production: false,
    apiUrl: 'https://sequencing-qa.transnetyx.com',

    auth0: {
        domain: 'login-qa.transnetyx.com',
        clientId: '3LB9XVPukE4s3wJtfVVTEQOsa3MEKbpQ',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-qa.transnetyx.com/v2/logout/sequencing`,
        logoutUrl: 'https://login-qa.transnetyx.com/v2/logout',
    },

    analytics: {
        enable: true,
        mixpanelCode: '52c907384e375a34d8eab040c987820f',
    },

    colonyUrl: 'https://colony-qa.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder-qa.transnetyx.com/Default.aspx',
    geneticMonitoringUrl: 'https://quickorder-qa.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder-qa.transnetyx.com/MVC/Microbiome/home',
    quickorderUrl: 'https://quickorder-qa.transnetyx.com/MVC/Account/Register',
    quickorderSettingsUrl: 'https://quickorder-qa.transnetyx.com/Account.aspx',
    quickorderPaymentSettingsUrl: 'https://quickorder-qa.transnetyx.com/PaymentMethods.aspx',
    quickorderMessagesUrl: 'https://quickorder-qa.transnetyx.com/Messages.aspx',
    ordersUrl: 'https://quickorder-qa.transnetyx.com/Orders.aspx',
    newOrdersUrl: 'https://quickorder-qa.transnetyx.com/Order1.StrainSelection.aspx',
    geneticMonitoringOrdersUrl: 'https://quickorder-qa.transnetyx.com/MVC/GeneticMonitoring/Orders',
    microbiomeOrdersUrl: 'https://quickorder-qa.transnetyx.com/MVC/Microbiome',
    accountSettingsUrl: 'https://accounts-qa.transnetyx.com/Account/Details',
    accountRegisterUrl: 'https://accounts-qa.transnetyx.com/register/quick-order',
    billingSettingsUrl: 'https://quickorder-qa.transnetyx.com/PaymentMethods.aspx',
    messageSettingsUrl: 'https://quickorder-qa.transnetyx.com/EmailPreferences.aspx',
    tissueUrl: 'https://tissue.transnetyx.com/',
    checkMateUrl: 'https://checkmate-qa.transnetyx.com/',
    registerUrl: 'https://login-qa.transnetyx.com/authorize',
};
